import { StyleSheet, Platform } from 'react-native'

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  view: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  icon: {
    marginLeft: 6,
    marginBottom: Platform.OS === 'ios' ? 1 : 0,
  },
  tabsStyle: {
    backgroundColor: Colors.white,
  },
  buttonStyle: {
    marginBottom: 33.7,
  },
  subHeaderRightComponent: {
    height: Platform.OS === 'ios' ? 32 : 30,
    width: Platform.OS === 'ios' ? 82 : 79,
  },
  subHeaderRightComponentStyle: {
    fontWeight: 'bold',
    fontSize: 14,
  },
  manualRefreshContainerStyle: {
    marginLeft: 0,
    marginBottom: 0,
  },
  subHeaderDescriptionContainer: {
    marginTop: 4,
  },
  headerStyle: {
    borderBottomWidth: 0,
  },
});
